module.exports = __webpack_public_path__ + "static/img/no3.97c89754.svg";